<template>
    <div class="my-10 mx-auto md:w-9/12 lg:w-7/12 ">
        <div class="h-full p-10 bg-white border rounded m-2">
            
            <h1 class="text-2xl mb-4 text-center"> Privacy Policy </h1>
            
            <p> Effective Date: 03/19/2024 </p>
            <p>
                Thank you for using NowRSS. Your privacy is important to us. This Privacy Policy explains how we collect, use, and protect your information when you use our Website and Extension.
            </p>
            
            <h3 class="text-xl my-4"> 1. Information We Collect </h3>
            <p>
                User Preferences: Selected export formats and other settings to enhance your experience.            
            </p>
            <p>
                Authentication Data: If applicable, JWT tokens for maintaining user sessions.
            </p>
            <p>
                Extracted Data: Structured data extracted from web pages for conversion into CSV files. 
            </p>
            <p>
                The Extension does not transmit this data to external servers.
            </p>
            <h3 class="text-xl my-4">2. How We Use Your Information</h3>
            <p>
                The collected information is used solely to:
            </p>
            <p>
                Enable core functionalities such as extracting and converting web page content into CSV files.
            </p>
            <p>
                Store user preferences for a personalized experience.
            </p>
            <p>
                Maintain authentication sessions securely (if applicable).
            </p>
            <p>
                We do not share, sell, or transmit your data to third parties.
            </p>
            <p>
                The Extension does not collect or store any personally identifiable information beyond what is necessary for its intended functionality.
            </p>
            <h3 class="text-xl my-4">
                3. Data Security
            </h3>
            <p>
                We implement industry-standard security measures to protect stored information. JWT tokens (if applicable) are stored securely within the browser's local storage and are never transmitted externally by the Extension.
            </p>
            <h3 class="text-xl my-4">
                4. Third-Party Services
            </h3>
            <p>
                This Extension does not use third-party analytics, tracking, or advertising services. Any extracted data remains on the user's device and is not shared with external entities.
            </p>
            <h3 class="text-xl my-4">
                5. Changes to This Privacy Policy
            </h3>
            <p>
                We may update this Privacy Policy from time to time. Any changes will be posted here with an updated effective date. Continued use of the Extension after changes constitute acceptance of the updated policy.
            </p>
            <h3 class="text-xl my-4">
                6. Contact Information
            </h3>
            <p>
                If you have any questions about this Privacy Policy, please contact us at contact@nowrss.com.
            </p>
           

        </div>
        
        

        
        
    </div>
</template>
  
<script>

export default {
    name: 'ContactUs',
    components: {

    },
    async mounted(){

    },
    data () {
        return {

        }
    }, 
    methods: {
        
    }
}
</script>
 
<style>

</style>
  
<div>

</div>



// WEBPACK FOOTER //
// src/pages/PrivacyPolicy.vue